import { useRecoilState } from "recoil";
import SelectCsSourceDialog from "./SelectCsSourceDialog";
import { csTargetSelectState } from "../../store/CopilotState";

function SelectCsSource() {
  const [csTargetSelect] = useRecoilState(csTargetSelectState);
  return (
    <>
      {
        csTargetSelect && <SelectCsSourceDialog/>
      }
    </>
  )
}

export default SelectCsSource;
